import React, { useContext } from 'react'
// nodejs library that concatenates strings
import classnames from 'classnames'
// reactstrap components
import { Button, Collapse, Navbar, NavItem, NavLink, Nav, Container } from 'reactstrap'

import { Link } from 'react-scroll'
import PanelContext from 'contexts/Panel'

function IndexNavbar() {
  const { year, semester, setYear, setSemester, years } = useContext(PanelContext)

  const [navbarColor, setNavbarColor] = React.useState('navbar-transparent')
  const [navbarCollapse, setNavbarCollapse] = React.useState(false)

  const toggleNavbarCollapse = () => {
    setNavbarCollapse(!navbarCollapse)
    document.documentElement.classList.toggle('nav-open')
  }

  const handleYearChange = ({ target: { value } }) => {
    const [ year, semester ] = value.split('.')
    setYear(parseInt(year))
    setSemester(parseInt(semester))
  }

  React.useEffect(() => {
    const updateNavbarColor = () => {
      if (document.documentElement.scrollTop > 30 || document.body.scrollTop > 30) {
        setNavbarColor('')
      } else if (document.documentElement.scrollTop < 30 || document.body.scrollTop < 30) {
        setNavbarColor('navbar-transparent')
      }
    }

    window.addEventListener('scroll', updateNavbarColor)

    return function cleanup() {
      window.removeEventListener('scroll', updateNavbarColor)
    }
  })
  return (
    <Navbar className={classnames('fixed-top', navbarColor)} expand="lg">
      <Container>
        <div className="navbar-translate d-flex align-items-center justify-content-between">
          <select id="select-year" className="form-select" aria-label="Selecione o ano" onChange={handleYearChange} style={{ marginLeft: 16 }}>
            {years.map(item => (
              <option value={item.value} selected={item.value === `${year}.${semester}`}>{item.label}</option>
            ))}
          </select>

          <button
            aria-expanded={navbarCollapse}
            className={classnames('navbar-toggler navbar-toggler', {
              toggled: navbarCollapse,
            })}
            onClick={toggleNavbarCollapse}
          >
            <span className="navbar-toggler-bar bar1" />
            <span className="navbar-toggler-bar bar2" />
            <span className="navbar-toggler-bar bar3" />
          </button>
        </div>

        <Collapse className="justify-content-end" navbar isOpen={navbarCollapse}>
          <Nav navbar>
            <NavItem style={{ marginTop: 0 }}>
              <NavLink>
                <Link
                  style={{
                    letterSpacing: 4,
                    paddingTop: 0,
                    cursor: 'pointer',
                    fontSize: 14,
                    textTransform: 'none',
                    fontWeight: 400,
                  }}
                  to="quem_somos"
                  spy
                  smooth
                  offset={-70}
                  duration={700}
                >
                  Quem Somos
                </Link>
              </NavLink>
            </NavItem>
            <NavItem style={{ marginTop: 0 }}>
              <NavLink>
                <Link
                  style={{
                    letterSpacing: 4,
                    paddingTop: 0,
                    cursor: 'pointer',
                    fontSize: 14,
                    textTransform: 'none',
                    fontWeight: 400,
                  }}
                  to="como_funciona"
                  spy
                  smooth
                  offset={-70}
                  duration={700}
                >
                  Como Funciona
                </Link>
              </NavLink>
            </NavItem>
            <NavItem style={{ marginTop: 0 }}>
              <Button className="btn-round" color="danger">
                <Link
                  style={{
                    letterSpacing: 4,
                    paddingTop: 0,
                    cursor: 'pointer',
                    fontSize: 14,
                    textTransform: 'none',
                    fontWeight: 600,
                  }}
                  to="cadastro"
                  spy
                  smooth
                  offset={-70}
                  duration={700}
                >
                  Cadastre-se
                </Link>
              </Button>
            </NavItem>
            <NavItem>
              <NavLink href="/login" style={{ backgroundColor: 'transparent', borderWidth: 0 }}>
                <h5
                  style={{
                    letterSpacing: 4,
                    fontWeight: 600,
                    fontSize: 14,
                    textTransform: 'none',
                    paddingTop: 0,
                  }}
                >
                  Entrar
                </h5>
              </NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  )
}

export default IndexNavbar
